/**
 * Content 组件 Widget 类（6.2 BaseWidget 体系）
 * RichText / FileUpload / Image / Video / Markdown
 */
import type { PropertyPaneConfig } from "@shared/types";

import { getMaterial } from "../materials";
import { BaseWidget } from "./base-widget";
import { buildMaterialPropertyPaneConfig } from "./property-pane";

function paneConfigFor(type: string, extraSections: PropertyPaneConfig[] = []): PropertyPaneConfig[] {
  return buildMaterialPropertyPaneConfig(getMaterial(type)?.propSchema ?? [], extraSections);
}

export class RichTextWidget extends BaseWidget {
  getWidgetType(): string {
    return "RichText";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("RichText");
  }
}

export class FileUploadWidget extends BaseWidget {
  getWidgetType(): string {
    return "FileUpload";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("FileUpload");
  }
  getMetaProperties(): Record<string, unknown> {
    return { isUploading: false, files: [] };
  }
}

export class ImageWidget extends BaseWidget {
  getWidgetType(): string {
    return "Image";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Image");
  }
}

export class VideoWidget extends BaseWidget {
  getWidgetType(): string {
    return "Video";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Video");
  }
}

export class MarkdownWidget extends BaseWidget {
  getWidgetType(): string {
    return "Markdown";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Markdown");
  }
}
